import React from 'react';
import { Section } from './ui/Section';
export function Guarantee() {
  return <Section data-id="element-131">
      <div className="bg-white border border-neutral-200 rounded-3xl p-8 md:p-12 text-center max-w-3xl mx-auto relative overflow-hidden shadow-sm" data-id="element-132">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-cta to-transparent opacity-50" data-id="element-133"></div>

        <div className="text-5xl mb-6" data-id="element-134">🛡️</div>
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-8 text-brand-title" data-id="element-135">
          GARANTÍA EL AUDITOR DE SKINCARE™ — 7 DÍAS
        </h2>

        <p className="font-body text-xl text-brand-text mb-6" data-id="element-136">
          Abres los 5 tomos. Revisas los 3 bonos. Aplicas el diagnóstico si
          quieres.
        </p>

        <p className="font-body text-xl text-brand-text mb-6" data-id="element-137">
          Si en 7 días no es lo que esperabas:
        </p>

        <div className="inline-block bg-brand-cta text-white font-heading font-black text-2xl md:text-3xl px-6 py-3 rounded-xl mb-6 transform -rotate-1 shadow-md" data-id="element-138">
          Te devolvemos el 100%.
        </div>

        <p className="font-body text-xl text-brand-text mb-8" data-id="element-139">
          Sin preguntas. Sin formularios. Sin drama.
        </p>
      </div>
    </Section>;
}